import { useMemo } from "react";

/**
 * useAuditUser
 * Lee del localStorage los datos del usuario logueado
 * y devuelve helpers para controlar permisos del módulo.
 *
 * Keys esperadas en localStorage:
 *   user      → username  (ej: "eduardo")
 *   auditor   → "1" / "0"
 *   controlador → "1" / "0"
 *   role      → "admin" / "usuario" / etc.
 */
export function useAuditUser() {
    const user = useMemo(() => {
        const username = localStorage.getItem("user") || "";
        const auditor = Number(localStorage.getItem("auditor")) || 0;
        const controlador = Number(localStorage.getItem("controlador")) || 0;
        const role = localStorage.getItem("role") || "usuario";

        return { username, auditor, controlador, role };
    }, []);

    /** Puede ver todos los ítems (auditor o admin) */
    const puedeVerTodo = user.role === "admin" || user.auditor === 1;

    /** Puede crear ítems */
    const puedeCrear = puedeVerTodo;

    /** Puede reasignar — todos los que tienen acceso al módulo */
    const puedeReasignar = puedeVerTodo || user.controlador === 1;

    /** Tiene acceso al módulo en general */
    const tieneAcceso = puedeVerTodo || user.controlador === 1;

    return {
        ...user,
        puedeVerTodo,
        puedeCrear,
        puedeReasignar,
        tieneAcceso,
    };
}